module.exports = __webpack_public_path__ + "img/v-chip.b29c25b9.svg";